module.exports = __webpack_public_path__ + "static/remorhaz-e02f5343cf2d18422015d612ae911748.jpeg";